module.exports = __webpack_public_path__ + "static/img/5.8525c2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mockups/screenshots/5.jpg
// module id = sGUK
// module chunks = 0